import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigContext } from './config-context';
export const ConfigProvider = function ConfigProvider(props) {
    const { children, config } = props;
    return (_jsx(ConfigContext.Provider, { value: config, children: children }));
};
